export const baseLang = {
  user: {
    en: 'User',
    es: 'Usuario'
  },
  users: {
    en: 'Users',
    es: 'Usuarios'
  },
  rol: {
    en: 'Rol',
    es: 'Rol'
  },
  DB: {
    en: 'DB',
    es: 'DB'
  },
  password: {
    en: 'Password',
    es: 'Contraseña'
  },
  login: {
    en: 'Login',
    es: 'Ingresar'
  },
  badCredentials: {
    en: 'Bad credentials',
    es: 'Credenciales incorrectas'
  },
  btnCerrarSecion: {
    es: 'Cerrar sesión',
    en: 'Logout'
  },
  btnGuardar: {
    es: 'Guardar',
    en: 'Save'
  },
  btnCancelar: {
    es: 'Cancelar',
    en: 'Cancel'
  },
  btnEliminar: {
    es: 'Eliminar',
    en: 'Delete'
  },
  btnEditar: {
    es: 'Editar',
    en: 'Edit'
  },
  btnNuevo: {
    es: 'Nuevo',
    en: 'New'
  },
  btnAceptar: {
    es: 'Aceptar',
    en: 'Accept'
  },
  btnBuscar: {
    es: 'Buscar',
    en: 'Search'
  },
  btnAgregar: {
    es: 'Agregar',
    en: 'Add'
  },
  btnCerrar: {
    es: 'Cerrar',
    en: 'Close'
  },
  bancos: {
    es: 'Bancos',
    en: 'Banks'
  },
  cuentasBancarias: {
    es: 'Cuentas Bancarias',
    en: 'Bank Accounts'
  },
  rangoCheques: {
    es: 'Rango de Cheques',
    en: ' Checks Range'
  },
  cheques: {
    es: 'Cheques',
    en: ' Checks'
  },
  rutas: {
    es: 'Routers',
    en: ' Routers'
  },
  marcasDisp: {
    es: 'Marcas Dispositivos',
    en: 'Brands Devices'
  },
  tipoDisp: {
    es: 'Tipo Dispositivos',
    en: 'Type Devices'
  },
  Actualizaciones: {
    es: 'Dispositivos Actualizados',
    en: 'Updated Devices'
  },
  transferencias: {
    es: 'Transferencias',
    en: 'Transfers'
  },
  red: {
    es: "Red",
    en: "Network",
  },
  video: {
    es: "Video",
    en: "Video",
  },
  telefonia: {
    es: "Telefonía",
    en: "Telephony",
  },
  origen: {
    es: "Origen",
    en: "Origin",
  },



  prestamos: {
    es: 'Préstamos Bancarios',
    en: ' Bank Loans'
  },
  inventarioC: {
    es: 'Inventario de Combustibles',
    en: 'Fluel Inventory'
  },
  transferenciasC: {
    es: 'Transferencias de Combustibles',
    en: 'Fluel Transfers'
  },
  generadores: {
    es: 'Generadores',
    en: 'Generators'
  },
  calderas: {
    es: 'Calderas',
    en: 'Boilers'
  },

  // Mensajes
  msgError: {
    es: "Error",
    en: "Error",
  },
  msgSuccess: {
    es: "Éxito",
    en: "Success",
  },
  msgWarning: {
    es: "Advertencia",
    en: "Warning",
  },

  editarUsuario: {
    es: "Editar usuario",
    en: "Edit user",
  },
  nuevoUsuario: {
    es: "Nuevo usuario",
    en: "New user",
  },
  eliminarUsuario: {
    es: "Eliminar usuario",
    en: "Delete user",
  },
  eliminarUsuarioMsg: {
    es: "¿Está seguro de eliminar el usuario?",
    en: "Are you sure to delete the user?",
  },
  configuracion: {
    es: "Configuración",
    en: "Configuration",
  },
  idioma: {
    es: "Idioma",
    en: "Language",
  },
  tema: {
    es: "Tema",
    en: "Theme",
  },
  inicio: {
    es: "Inicio",
    en: "Home",
  },
  msgConfigGuardada: {
    es: "Configuración guardada.",
    en: "Configuration saved.",
  },
  msgErrorConfig: {
    es: "Error al guardar la configuración.",
    en: "Error saving configuration.",
  },

  //--------------------------------------------- DASHBOARD---------------------------------------
  pDiaria: {
    es: "Producción Diaria (Kg)",
    en: "Daily Production (Kg)",
  },
  pDiariaTitle: {
    es: "Producción Total - Semana",
    en: "Total Production Week",
  },
   pDiariaTitleCotton: {
    es: "Producción Algodón - Semana",
    en: "Cotton Production Week",
  },
  pDiariaTitleSynthetic: {
    es: "Producción Sintético - Semana",
    en: "Synthetic Production Week",
  },
  pMensual: {
    es: "Producción Mensual",
    en: "Monthly Production",
  },
  ventasAnuales: {
    es: "Ventas (Millones de dolares)",
    en: "Sales (Millions of dollars)",
  },
  ventas: {
    es: "Ventas",
    en: "Sales",
  },
  ventasCliente: {
    es: "Ventas Por Cliente",
    en: "Sales For Customer",
  },
  ventasMiles: {
    es: "Ventas (Miles de Dólares)  - ",
    en: "Sales (Thousands of Dollars) - ",
  },
  presupuesto: {
    es: "Presupuesto",
    en: "Budget",
  },
  ventasMesuales: {
    es: "Ventas Mensuales",
    en: "Monthly Sales",
  },
  prodTinto: {
    es: "Metas de Producción de Tintorería (Kg)",
    en: "Dry Cleaning Production Goals (Kg)",
  },
  prodTintoTooltip: {
    es: "Metas por Categoría",
    en: "Goals by Category",
  },
  personalTotal: {
    es: "Personas por Área",
    en: "People by Area",
  },
  personalTotalG: {
    es: "Personas por Área General",
    en: "People by General area",
  },
  metricas: {
    es: "Métricas",
    en: "Metricas",
  },
  regmetricas: {
    es: "Registro Métricas",
    en: "Metrics Log",
  },

  // COTIZACIONES
  cotizaciones: {
    es: "Cotizaciones",
    en: "Quotations",
  },
  cotizacionesCost: {
    es: "Costos de Cotizaciones",
    en: "Cost Quote",
  },
  knitCost: {
    es: "Costo de Tejido",
    en: "Knit Cost"
  },
  dyeCost: {
    es: "Costo de Teñido",
    en: "Dye Cost"
  },
  additionalCost: {
    es: "Costos Procesos Especiales",
    en: "Cost Special Processes"
  },
  yarnTitle: {
    es: "Hilo",
    en: "Yarn"
  },
  fabricStyle: {
    es: "Estilo de Tejido",
    en: "Fabric Style"
  },
  yarnQty: {
    es: "Cantidad de Hilos",
    en: "Yarn Quantity"
  },
  PorcentageY1: {
    es: 'Porcentaje Hilo 1',
    en: 'Porcentage Yarn 1'
  },
  PorcentageY2: {
    es: 'Porcentaje Hilo 2',
    en: 'Porcentage Yarn 2'
  },
  PorcentageY3: {
    es: 'Porcentaje Hilo 3',
    en: 'Porcentage Yarn 3'
  },
  dyeType: {
    es: "Tipo de Teñido",
    en: "Dye Type"
  },
  density: {
    es: "Densidad",
    en: "Density"
  },
  detail: {
    es: "Detalles",
    en: "Details"
  },
  cotizacion: {
    es: "Cotización",
    en: "Quotation",
  },
  NoCotizacion: {
    es: "No. Cotización",
    en: "No. Quotation",
  },
  fecha: {
    es: "Fecha",
    en: "Date",
  },
  cliente: {
    es: "Cliente",
    en: "Customer",
  },
  buyer: {
    es: "Buyer",
    en: "Buyer",
  },
  agente: {
    es: "Agente de Ventas",
    en: "Sales Agent",
  },
  termC: {
    es: "Término de compra",
    en: "Payment Term",
  },
  termS: {
    es: "Término de envío",
    en: "Shipment Term",
  },
  comentario: {
    es: "Comentario",
    en: "Comment",
  },
  cancelar: {
    es: "Cancelar",
    en: "Cancel",
  },
  agregar: {
    es: "Agregar",
    en: "Add",
  },
  agregarDet: {
    es: "Agregar Detalle",
    en: "Add Detail",
  },
  estilo: {
    es: "Estilo de Categoría",
    en: "Style Category",
  },
  yarn: {
    es: "Hilo 1",
    en: "Yarn 1",
  },
  yarn2: {
    es: "Hilo 2",
    en: "Yarn 2",
  },
  yarn3: {
    es: "Hilo 3",
    en: "Yarn 3",
  },
  fabric: {
    es: "Estilo de Tejido",
    en: "Fabric Style",
  },
  colorante: {
    es: "Tipo de Teñido",
    en: "Dye Type",
  },
  densidad: {
    es: "Densidad",
    en: "Density",
  },
  unidad: {
    es: "Unidad",
    en: "Unit",
  },
  cantidad: {
    es: "Cantidad $",
    en: "Quantity $",
  },
  costoA: {
    es: "Costos Adicionales",
    en: "Additional Costs",
  },
  costoO: {
    es: "Otros Costos",
    en: "Other Cost",
  },
  costoT: {
    es: "Costo Tejido",
    en: "Knit Cost",
  },
  costoC: {
    es: "Costo Teñido",
    en: "Dye Cost",
  },
  costoUnit: {
    es: "Precio",
    en: "Price",
  },
  costoP: {
    es: "Costos Procesos Especiales",
    en: "Special Processes Cost",
  },
  agregarCostoT: {
    es: "Agregar Costo de Tejido",
    en: "Add Knit Cost",
  },
  editarCostoT: {
    es: "Editar Costo de Tejido",
    en: "Edit Knit Cost",
  },
  estado: {
    es: "Estado",
    en: "Status",
  },
  precio: {
    es: "Precio",
    en: "Price",
  },

  agregarCostoC: {
    es: "Agregar Costo de Teñido",
    en: "Add Dye Cost",
  },
  editarCostoC: {
    es: "Editar Costo de Teñido",
    en: "Edit Dye Cost",
  },

  agregarCostoA: {
    es: "Agregar Costo de Proceso",
    en: "Add Process Cost",
  },
  editarCostoA: {
    es: "Editar Costo de Proceso",
    en: "Edit Process Cost",
  },
  agregarCostoOtros: {
    es: "Agregar Costo Adicional",
    en: "Add Additional Cost",
  },
  editarCostoOtros: {
    es: "Editar Costo Adicional",
    en: "Edit Additional Cost",
  },
  processCost: {
    es: "Descripción",
    en: "Description",
  },
  desc: {
    es: "Descripción",
    en: "Description",
  },
  agregarHilo: {
    es: "Agregar Hilo",
    en: "Add Yarn",
  },
  editarHilo: {
    es: "Editar Hilo",
    en: "Edit Yarn",
  },
  title: {
    es: "Título",
    en: "Title",
  },
  agregarEstiloT: {
    es: "Agregar Estilo de Tejido",
    en: "Add Fabric Style",
  },
  editarEstiloT: {
    es: "Editar Estilo de Tejido",
    en: "Edit Fabric Style",
  },
  est: {
    es: "Estilo",
    en: "Style",
  },
  agregarTipoC: {
    es: "Agregar Tipo de Teñido",
    en: "Add Dye Type",
  },
  editarTipoC: {
    es: "Editar Tipo de Teñido",
    en: "Edit Dye Type",
  },
  tipo: {
    es: "Tipo",
    en: "Type",
  },
  agregarDensidad: {
    es: "Agregar Densidad",
    en: "Add Densidad",
  },
  editarDensidad: {
    es: "Editar Densidad",
    en: "Edit Densidad",
  },

  OtherCost: {
    es: "Otros Costos",
    en: "Others Costs",
  },

  addKnit: {
    es: "Agregar Costo de Tejido",
    en: "Add Knit Cost",
  },
  addDye: {
    es: "Agregar Costo de Teñido",
    en: "Add Dye Cost",
  },
  addProcess: {
    es: "Agregar Costo de Procesos",
    en: "Add Process Cost",
  },
  addAdditional: {
    es: "Agregar Costo Adicional",
    en: "Add Additional Cost",
  },
  Calibres: {
    es: "Calibre",
    en: "Caliber",
  },
  Types: {
    es: "Tipos",
    en: "Types",
  },
  Efectos: {
    es: "Efectos",
    en: "Effects",
  },
  Fibras: {
    es: "Fibras",
    en: "Fibers",
  },
  'Types Cotton': {
    es: "Composición de algodón",
    en: "Cotton composition",
  },
  Loster: {
    es: "Luster",
    en: "Luster",
  },
  Recycled: {
    es: "Reciclado",
    en: "Recycled",
  },
  Cross: {
    es: "Cross",
    en: "Cross",
  },
  Procesos: {
    en: 'Process',
    es: 'Procesos'
  },
  AutorizarNota: {
    en: 'Authorize Credit Note',
    es: 'Autorizar Nota de Crédito'
  },
  OrdenesVenta: {
    en: 'Sales Orders',
    es: 'Ordenes de Venta'
  },
  listadoTab: {
    en: 'List',
    es: 'Listado'
  },
  detallesTab: {
    en: 'Details',
    es: 'Detalles'
  },

  tiposPago:{
    en:'Payment Type',
    es:'Tipos de Pago'
  },
  TipoPago:{
    en:'Payment Type',
    es:'Tipo Pago'
  },
  Descripcion:{
    en:'Description',
    es:'Descripción'
  },
  Estado:{
    en:'Status',
    es:'Estado'
  },
  Comision:{
    en:'Commission',
    es:'Comisión'
  },
  Retencion:{
    en:'Retention',
    es:'Retención'
  },
  BodegaMateriales:{
    en:'Warehouse Materials',
    es:'Bodega Materiales'
  },
  BodegaQC:{
    en:'CD Warehouse',
    es:'Bodega QC'
  },
  BodegaQC2:{
    en:'Chemicals and Dyes',
    es:'Quimicos y Colorantes'
  },
  BodegaHilaza:{
    en:'Yarn Warehouse',
    es:'Bodega Hilaza'
  },
  Combustibles:{
    en:'Fuel Inventory',
    es:'Inventario Combustibles'
  },
  BalanceHilaza:{
    es:'Balance Hilaza',
    en:'Yarn Balance'
  },
  Algodon:{
    es:'Algodón',
    en:'Cotton'
  },
  Sintetico:{
    es:'Sintético',
    en:'Synthetic'
  },
  Tecnico:{
    es:'Técnico',
    en:'Technician'
  }
};

